<template>
    <custom-container-main>
        <div class="row">
            <div class="col-lg-12">
                <div class="block-content">
                    <div style="max-width: 390px; margin: auto">
                        <h4 class="c-question c-question-first">¿Cómo desea la planta?</h4>
                        <eco-type-buttons v-model="eco" style="font-size: 1.2em"></eco-type-buttons>
                        <p class="c-p">Siempre podrás volver a editar tus selecciones más adelante</p>
                        <btn-next class="type-select-btn-next" :disabled-next="disabledNext" @click="goNext" :btn-back="false" :no-margin-bottom="hasLinesInSummary"></btn-next>
                        <div class="btn-go-summary-container">
                            <b-button variant="outline-secondary" v-show="hasLinesInSummary" @click="goSummary" class="go-new-btn" v-b-tooltip.hover title="Borrar el progreso actual y va al resumen del presupuesto">
                                Ir al resumen
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </custom-container-main>
</template>

<script>
    import BtnNext from "./BtnNext";
    import CustomContainerMain from "./CustomContainerMain";
    import EcoTypeButtons from "./EcoTypeButtons";

    export default {
        name: "TypeSelect",
        components: {
            EcoTypeButtons,
            BtnNext, CustomContainerMain
        },
        props: {
            budgetData: {
                type: [Object, null],
                default: null
            }
        },
        data() {
            return {
                eco: null,
                saving: false,
            }
        },
        computed: {
            disabledNext() {
                return this.eco === null || this.saving;
            },
            hasLinesInSummary() {
                let more = false;
                if (this.budgetData) {
                    more = !!this.budgetData.has_lines_in_summary;
                }
                return more;
            }
        },
        watch: {
            budgetData() {
                this.setBudgetData();
            }
        },
        methods: {
            setBudgetData() {
                let eco = null;
                if (this.budgetData) {
                    eco = !!this.budgetData.eco_type;
                }
                this.eco = eco;
            },
            goNext() {
                let vm = this;
                vm.saving = true;
                let formData = new FormData();
                formData.append('eco', vm.eco ? 1 : 0);
                axios.post(vm.route('custom.type-select-next'), formData).then((response) => {
                    window.location = vm.route('custom.index');
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                }).finally(() => {
                    vm.saving = false;
                });
            },
            goSummary() {
                return axios.post(this.route('custom.reset-line')).then((response) => {
                    window.location = this.route('custom.summary');
                }).catch((e) => {
                    Vue.toasted.show('Ha ocurrido un error', {
                        type: "error",
                        duration: 3000
                    });
                    console.log(e);
                });
            }
        },
        created() {
            this.setBudgetData();
        }
    }
</script>

<style scoped>
    .block-content {
        text-align: center;
    }

    .c-question-first {
        padding-top: 1.2em;
    }

    .c-p {
        margin-top: 0.75em;
        margin-bottom: 0.75em;
        /*font-size: 1.2em*/
    }

    .c-show-benefits {
        margin-top: 0.5em;
        margin-bottom: 1.5em;
    }

    .c-show-benefits > button {
        background: #ffffff;
        font-weight: bold;
        color: #008A83;
        border-color: #008A83;
        border-width: 2px;
    }

    .c-show-benefits h6 {
        color: #008A83;
        font-weight: bold;
    }

    .c-show-benefits p, .c-show-benefits h6 {
        text-align: justify;
    }


    .c-question {
        font-weight: bold;
        font-size: 1.25rem;
    }

    .btn-go-summary-container {
        display: flex;
        align-items: center;
        max-width: 380px;
        margin: auto;
    }

    .go-new-btn {
        border-radius: 0;
        color: #0b72b8;
        border: 2px solid #0b72b8;
        font-weight: bold;
        width: 100%;
        margin-bottom: 2em;
        margin-top: 1em;
    }

    .go-new-btn:hover {
        background-color: #c9c9c9;
    }

    @media (min-width: 575px) {
        .type-select-btn-next {
            margin-bottom: 2em;
        }
    }

    @media (min-width: 992px) {
        .c-question-first {
            padding-top: 2.2em;
        }

        .c-question {
            padding-bottom: 0.8em;
        }

        .c-p {
            margin-top: 1.25em;
            margin-bottom: 1.25em;
            /*font-size: 1.2em*/
        }

    }


</style>
